/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { termsEditorCommon as terms } from "../../terms/common";

export function registerMenus(dc: IEditor): void {
	const menuSvc = dc.get("menuService");

	menuSvc.registerMenuItem("main.create", {
		id: "themeEditor",
		label: terms.mainMenu.sectionCreate.theme.label,
		tooltip: terms.mainMenu.sectionCreate.theme.tooltip,
		icon: "mdi/shape-outline",
		flags: [ "primary" ],
		order: 130,
		commandId: "themeEditor.createPage.open"
	});
}
